export enum ConnetorColorCodes{
    GREEN = "green",
    ORANGE = "orange",
    RED = "red",
    UNAVBLE = "#5E1914"
}

export enum ConnectorStatus{
    AVAILABLE = "Available",
    PARTIALLY = "Partially Available",
    BUSY = "Busy",
    UNAVAILABLE = "UnAvailable"
}